<script setup>
import { get, post } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import MemPicker from '@/components/MemPicker.vue'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive, Teleport } from 'vue'
const metaStore=useMetaStore()
,meta=reactive({headers:[{tk:'ON/OFF',col:'enabled'},{tk:'eventname',col:'nm'},{tk:'shippingmethod',col:'shippingmethod'},{tk:'man_tar',col:'targetids'}]
  ,items:[{tk:'signup'},{tk:'oneonone_inquery'},{tk:'roadview_price_inquery'},{tk:'applyforanopenapi'},{tk:'server_error'}],shippingmethod:['email','sms','kakaotalk','slack']
  ,sel:{}})
,save=async()=>{
  const pms=meta.items.map(item=>({nm:item.tk,enabled:item.enabled==true,targettype:item.targettype,id:item.id,shippingmethod:item.shippingmethod.toString()}))
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/modalarmdetails',pms)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  init()
},pop=(type,nm)=>{
  meta.poptype=null
  meta.selnm=nm
  if(_.isEmpty(type)||type.toString().includes('Event'))return metaStore.pop({ison:false})
  if(type=='target')meta.targettype=meta.items.find(item=>item.tk==meta.selnm).targettype
  if(type=='save'){
    meta.popttl=metaStore.t('alarmlist')+' '+metaStore.t('save')
    meta.popcont=metaStore.t('save_con')
  }
  metaStore.pop({ison:true,callback:()=>meta.poptype=type})
},targetSaved=type=>{
  meta.items.find(item=>item.tk==meta.selnm).targettype=type
},init=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/admin/alarmdetails')
  metaStore.blockLoading(false)
  res.data.forEach(al=>{
    const item=meta.items.find(item=>item.tk==al.nm)
    meta.headers.forEach(head=>item[head.col]=al[head.col])
    item.id=al.id
    if(al.shippingmethod)item.shippingmethod=al.shippingmethod.split(',')
    else item.shippingmethod=[]
  })
}
meta.items.forEach(item=>{
  item.shippingmethod=[]
  item.targettype='all'
})
init()
</script>
<template>
<v-card flat>
  <v-card-title>
    <v-row no-gutters>
      <v-col class="text-subtitle-1">
        {{ $t('alarmlist') }}
      </v-col>
      <v-col class="text-end">
        <v-btn class="me-5" @click="init">{{ $t('refresh') }}</v-btn>
        <v-btn color="primary" @click="pop('save')">{{ $t('save') }}</v-btn>
      </v-col>
    </v-row>
  </v-card-title>
  <v-card-text>
    <v-table>
      <thead>
        <tr>
          <th v-for="header in meta.headers" class="text-center">{{header.col=='enabled'?header.tk:$t(header.tk)}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in meta.items" class="text-center">
          <td v-for="header in meta.headers">
            <v-switch v-if="header.col=='enabled'" class="center" color="primary" v-model="item.enabled"/>
            <div v-else-if="header.col=='nm'">{{ $t(item.tk) }}</div>
            <div v-else-if="header.col=='shippingmethod'" class="d-flex justify-center">
              <v-checkbox v-for="method in meta.shippingmethod" v-model="item.shippingmethod" :value="method" :label="$t(method)"/>
            </div>
            <div v-else><v-btn :text="$t(header.tk)" @click="pop('target',item.tk)"/></div>
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-card-text>
</v-card>
<Teleport v-if="meta.poptype" to="#popbody">
  <MemPicker v-if="meta.poptype=='target'" tkey="tar_list" refnm="alarmdetail" auth="ADMIN" :targettypes="['all','partial']" :targettype="meta.targettype" @close-pop="metaStore.pop({ison:false})" @save-callback="targetSaved"/>
  <ConfirmCard v-if="meta.poptype=='save'" :ttl="meta.popttl" :cont="meta.popcont" @cancel="metaStore.pop({ison:false})" @confirm="save"/>
</Teleport>
</template>
